import React from 'react';
import ReactDOM from 'react-dom/client';
import htm from 'htm';
import * as Recharts from 'recharts';
import * as LucideReact from 'lucide-react';

// Expose React globally for htm-setup.js compatibility
// This allows the existing htm-based code to continue working
// while we migrate components to JSX incrementally
(window as { React?: typeof React }).React = React;
(window as { ReactDOM?: typeof ReactDOM }).ReactDOM = ReactDOM;

// Expose Recharts globally for chart components
(window as { Recharts?: typeof Recharts }).Recharts = Recharts;

// Expose Lucide icons globally
(window as { lucideReact?: typeof LucideReact }).lucideReact = LucideReact;

// Create and expose htm binding globally
const html = htm.bind(React.createElement);
// htm is a tagged template function, not the module itself
(window as unknown as { htm?: typeof htm }).htm = htm;

// Export for potential future use
export { html };

// Dynamic import of the main App component
// The existing app.js mounts itself using ReactDOM.createRoot
// so we just need to ensure the environment is set up before it loads
import('./app');
